import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useQuery } from "react-query";
import { getCards, searchCard } from "../../../api/apiServices";
import toast, { Toaster } from "react-hot-toast";
import Pagination from "../../../services/Pagination";

const GlobalCards = () => {
	const [card, setCard] = useState([]);
	const [search, setSearch] = useState(false);

	const [pf_number, setPFNumber] = useState(null);
	const [first_name, setFirstName] = useState(null);
	const [last_name, setLastName] = useState(null);

	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage, setPostPerPage] = useState(20);

	const {
		isLoading,
		isError,
		error,
		data: cards,
	} = useQuery("cards", getCards, {
		select: (data) => data.sort((a, b) => b.id - a.id),
		keepPreviousData: true,
	});

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/global_cards";

	const handleSearch = async (e) => {
		e.preventDefault();

		const searchData = {
			pf_number: pf_number,
			first_name: first_name,
			last_name: last_name,
		};
		try {
			await searchCard(searchData)
				.then((res) => {
					if (res.length > 0) {
						setCard(res);
						setSearch(true);
					} else {
						toast.success("Member card information not found");
					}
				})
				.catch((err) => {
					toast.error("Provide at least one search parameter ");
					return false;
				});
		} catch (err) {
			toast.error(err);
		}
	};

	let currentPosts = [];
	const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;
	if (!search) {
		currentPosts = cards?.slice(indexOfFirstPage, indexOfLastPage);
	} else {
		currentPosts = card?.slice(indexOfFirstPage, indexOfLastPage);
	}

	const handleCancel = () => {
		setPFNumber("");
		setFirstName("");
		setLastName("");
		setSearch(false);
		navigate(from, { replace: true });
	};

	let searchContent = (
		<form onSubmit={handleSearch}>
			<div className="form-group row">
				<div className="col-sm-3">
					<input
						className="form-control"
						type="text"
						placeholder="PF Number"
						style={{ textTransform: "uppercase" }}
						onChange={(e) => setPFNumber(e.target.value)}
						value={pf_number}
					/>
				</div>
				<div className="col-sm-3">
					<input
						className="form-control"
						type="text"
						placeholder="FirstName"
						style={{ textTransform: "uppercase" }}
						onChange={(e) => setFirstName(e.target.value)}
						value={first_name}
					/>
				</div>
				<div className="col-sm-3">
					<input
						className="form-control"
						type="text"
						placeholder="LastName"
						style={{ textTransform: "uppercase" }}
						onChange={(e) => setLastName(e.target.value)}
						value={last_name}
					/>
				</div>
				<button type="submit" className="btn btn-success ">
					{" "}
					<i className="fa fa-search"></i> Search Member
				</button>
			</div>
		</form>
	);

	let content;
	if (isLoading) {
		content = <p>Loading Membership Cards...</p>;
	} else if (isError) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<div className="table-responsive lg">
				<table className="table table-bordered">
					<thead>
						<tr>
							<th scope="col" style={{ textAlign: "center" }}>
								#
							</th>
							<th scope="col">PF Number</th>
							<th scope="col">Name</th>
							<th scope="col">Region</th>
							<th scope="col">Printed</th>
							<th scope="col">issued</th>
							<th scope="col">Date issued</th>
							<th scope="col" style={{ textAlign: "center" }}>Action</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts.map((card, index) => (
							<tr key={card.id}>
								<td style={{ textAlign: "center" }}>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{card.pf_number}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{card.first_name}&nbsp;{card.middle_name}
									&nbsp;{card.last_name}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{card.region}
								</td>
								<td style={{ textAlign: "center" }}>
									{card.received_from_printer ? "YES" : "NO"}
								</td>
								<td style={{ textAlign: "center" }}>
									{card.issued_status ? "YES" : "NO"}
								</td>
								<td style={{ textAlign: "center" }}>
									{card.date_issued}
								</td>
								<td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
									<div style={{ display: "inline-block" }}>
										<Link
											to={`/view_card/${card.id}`}
											className="small"
										>
											<i className="fa fa-eye"></i> view
										</Link>
									</div>
									&nbsp; &nbsp;
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Card Management - Global Cards</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="row">
								<div class="col-sm-2">
									<button
										className="btn btn-success btn-block"
										to="/sent_to_printer"
									>
										<i className="fa fa-upload"></i>&nbsp;
										&nbsp;Sent To Printer
									</button>
								</div>
								<div class="col-sm-2">
									<button
										className="btn btn-success btn-block"
										to="/received_from_printer"
									>
										<i className="fa fa-plus"></i>&nbsp;
										&nbsp;Receive From Printer
									</button>
								</div>
								<div class="col-sm-2">
									<button
										className="btn btn-success btn-block"
										to="/card/issue"
									>
										<i className="fa fa-close"></i>&nbsp;
										&nbsp; Issue To Members
									</button>
								</div>
								<div class="col-sm-2">
									<button
										className="btn btn-success btn-block"
										to="/card/create"
									>
										<i className="fa fa-close"></i>&nbsp;
										&nbsp; Send To Regions
									</button>
								</div>
							</div>
							<hr />
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											{searchContent}
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{content}</div>
							<div className="panel-footer">
								{cards && !search ? (
									<Pagination
										data={cards}
										postPerPage={postPerPage}
										currentPage={currentPage}
										setCurrentPage={setCurrentPage}
										setPostPerPage={setPostPerPage}
									/>
								) : (
									<div className="search-group">
										<button
											type="submit"
											className="btn btn-danger "
											onClick={handleCancel}
										>
											{" "}
											<i className="fa fa-search"></i>{" "}
											Cancel
										</button>
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="box-footer"></div>
				</div>
			</section>
		</>
	);
};

export default GlobalCards;
